import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { australiaPostPrinterlessDefault } from "./default-texts";

export interface AustraliaPostPrinterlessSettings {
  australiaPostPrinterless?: {
    enabled?: boolean | null;
    text?: string | null;
  } | null;
}

export function australiaPostPrinterlessNote(
  returnsSettings: AustraliaPostPrinterlessSettings | null | undefined,
  carrier: string | null | undefined,
): string | undefined {
  const setting = returnsSettings?.australiaPostPrinterless;
  if (!setting?.enabled || carrier !== Carriers.AUSTRALIA_POST) {
    return undefined;
  }
  return setting.text?.trim() || australiaPostPrinterlessDefault();
}
